import React from "react";
import {
  CommandBar,
  SearchBox,
  Dropdown,
  Button,
} from "office-ui-fabric-react";
import { browserHistory as history } from "react-router";
import { connect } from "react-redux";
import axios from "axios";
import config from "../../config";
import { PATIENT_ASSIGNMENT } from "../../constants/enums";
import ROUTE from "../../constants/routes";

export class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
    };

    var user = this.props.auth.user;
  }

  componentDidMount() {
    axios.get(`${config.apiUrl}/files`).then(({ data }) => {
      data = data.filter((e) => e.tag);
      this.setState({
        files: data,
      });
    });
  }

  searchBoxChange(filter, text) {
    clearTimeout(this.idTimeout);
    this.idTimeout = setTimeout(() => {
      this.props.dispatch({
        type: "search_box_update",
        payload: {
          filter,
          text,
        },
      });
    }, 500);
  }

  render() {
    
    var items = navBar.items;
    var farItems = [];
    var user = this.props.auth.user;
    if(user.orgType=='vendor')
      user.accountType = user.orgType;

    if (user) {
      var name;
        
      if(user.orgType)
        name = user.orgType? user.name : "unknow";
      else{
        name = user.fname+ " " + user.lname + "|";
        name += user.office ? user.office.name : "unknow"
      }
        
      farItems = farItems.concat([
        // {
        //   key: "searchbarFilter",
        //   onRender: () => (
        //     <Dropdown
        //       selectedKey={this.props.searchBox.filter}
        //       onChanged={(v) =>
        //         this.searchBoxChange(v.key, this.props.searchBox.text)
        //       }
        //       styles={{ width: 80 }}
        //       options={[
        //         { key: "", text: "All" },
        //         { key: "city", text: "City" },
        //       ]}
        //     />
        //   ),
        //   className: "nav-item__search-filter",
        // },
        // {
        //   key: "searchbar",
        //   onRender: () => (
        //     <SearchBox
        //       value={this.props.searchBox.text}
        //       onChange={(v) =>
        //         this.searchBoxChange(this.props.searchBox.filter, v)
        //       }
        //     />
        //   ),
        //   className: "nav-item__search-box",
        // },
        /* name: `${user.fname} ${user.lname} | ${
            user.office ? user.office.name : "unknow"
          }`*/
        {
          name: name,
          key: "profile",
          items: [
            {
              name: "Break in",
              key: "breakin",
              onClick: function () {
                axios
                  .post(config.apiUrl + "/auth/traking", {
                    type: "break-in",
                  })
                  .then(() => {
                    localStorage.breakin = new Date().getTime().toString();
                    window.location.reload();
                  });
              },
            },
            {
              name: "Logout",
              key: "logout",
              onClick: function () {
                axios.post(config.apiUrl + "/auth/logout").then(() => {
                  localStorage.clear();
                  window.location.href = "/";
                });
              },
            },
          ],
        },
      ]);

      if (user.accountType !== "admin") {
        items = items.filter((e) => e.key != "approve");
      }

      items = navBar.items
        .filter((tab) => tab.roles.indexOf(user.accountType) >= 0)
        .map((tab) => {
          const updatedTab = tab;
          if (Array.isArray(updatedTab.items)) {
            updatedTab.items = updatedTab.items.filter((opt) => {
              return opt.roles.indexOf(user.accountType) >= 0;
            });
          }

          return updatedTab;
        });
    }

    if (this.state.files.length > 0) {
      var importedItem = items.find((e) => e.key === "info");
      if (importedItem) {
        importedItem.onClick = null;
        importedItem.items = this.state.files.map((e) => ({
          name: e.tag,
          key: "importdata" + e._id,
          roles: ["staff", "admin", "manager"],
          onClick: function () {
            history.push("/imported-data?tag=" + e._id);
          },
        }));
        importedItem.items = [
          {
            name: "All data",
            key: "Zipcode Data",
            roles: ["staff", "admin", "manager"],
            onClick: function () {
              history.push("/info-list");
            },
          },
        ].concat(importedItem.items);
      }
    }

    return (
      <div className="medicentric-navbar" style={{ height: 40, width: "100%" }}>
        <CommandBar items={items} farItems={farItems} shiftOnReduce />
        {/* <div className="navbar-search">
          <Dropdown
            selectedKey={this.props.searchBox.filter}
            onChanged={(v) =>
              this.searchBoxChange(v.key, this.props.searchBox.text)
            }
            styles={{ width: 80 }}
            options={[
              { key: "", text: "All" },
              { key: "city", text: "City" },
            ]}
          />
          <SearchBox
            value={this.props.searchBox.text}
            onChange={(v) =>
              this.searchBoxChange(this.props.searchBox.filter, v)
            }
          />
        </div> */}
      </div>
    );
  }
}

function mapStateToProps(state, own_props) {
  return {
    auth: state.auth,
    searchBox: state.app.searchBox || { filter: "", text: "" },
  };
}
export default connect(mapStateToProps)(NavBar);

const navBar = {
  items: [
    {
      name: "",
      key: "medicentric",
      icon: "HomeSolid",
      roles: ["admin"],
      onClick: function () {
        history.push("/");
      },
    },
    {
      name: "Info",
      key: "info",
      roles: ["admin", "manager", "staff"],
      onClick: function () {
        history.push("/info-list");
      },
    },
    {
      name: "Lead Generator",
      key: "lead-generator",
      roles: ["admin", "manager", "staff"],
      onClick: function () {
        history.push(ROUTE.LEAD_GENERATOR_DASHBOARD);
      },
    },
    {
      name: "Central",
      key: "Central",
      roles: ["central-user", "admin", "manager","closer"],
      onClick: function () {
        history.push("/assign-to-closer");
      },
      // items: [
      //   {
      //     name: "All",
      //     key: "central_all",
      //     roles: ["central-user", "admin", "manager"],
      //     onClick: () => history.push("/assign-to-closer"),
      //   },
      //   {
      //     name: "Home Health",
      //     key: "central_home_health",
      //     roles: ["central-user", "admin", "manager"],
      //     onClick: () =>
      //       history.push({
      //         pathname: "/assign-to-closer",
      //         state: { pa: PATIENT_ASSIGNMENT.HOME_HEALTH },
      //       }),
      //   },
      //   {
      //     name: "Hospice",
      //     key: "central_hospice",
      //     roles: ["central-user", "admin", "manager"],
      //     onClick: () =>
      //       history.push({
      //         pathname: "/assign-to-closer",
      //         state: { pa: PATIENT_ASSIGNMENT.HOSPICE },
      //       }),
      //   },
      //   {
      //     name: "Clinic",
      //     key: "central_clinic",
      //     roles: ["central-user", "admin", "manager"],
      //     onClick: () =>
      //       history.push({
      //         pathname: "/assign-to-closer",
      //         state: { pa: PATIENT_ASSIGNMENT.CLINIC },
      //       }),
      //   },
      //   {
      //     name: "Sign Up",
      //     key: "central_sign_up",
      //     roles: ["central-user", "admin", "manager"],
      //     onClick: () =>
      //       history.push({
      //         pathname: "/assign-to-closer",
      //         state: { pa: PATIENT_ASSIGNMENT.SIGN_UP },
      //       }),
      //   },
      // ],
    },
    /*{
      name: "Closer",
      key: "closer_closer",
      roles: ["closer"],

      onClick: () =>
        history.push({
          pathname: "/lead",
          state: {
            isCloser: true,
          },
        }),
    },*/
    {
      name: "Vendor",
      key: "vendor",
      roles: ["admin"],
      onClick: function () {
        history.push(ROUTE.VENDOR_DASHBOARD);
      },
    },
    /*{
      name: "Driver",
      key: "driver",
      roles: ["vendor","admin"],
      onClick: function () {
        history.push(ROUTE.DRIVER_DASHBOARD);
      },
    }
    ,
    {
      name: "Clinic",
      key: "clinic",
      roles: ["admin"],
      onClick: function () {
        history.push(ROUTE.CLINIC_DASHBOARD);
      },
    },*/
    /*{
      name: "Home Health",
      key: "closer_closer_homehealth",
      roles: ["closer"],
      onClick: () =>
        history.push({
          pathname: "/lead",
          state: { pa: PATIENT_ASSIGNMENT.HOME_HEALTH, isCloser: true },
        }),
    },
    {
      name: "Hospice",
      key: "closer_closer_hospice",
      roles: ["closer"],
      onClick: () =>
        history.push({
          pathname: "/lead",
          state: { pa: PATIENT_ASSIGNMENT.HOSPICE, isCloser: true },
        }),
    },
    {
      name: "Clinic",
      key: "closer_closer_clinic",
      roles: ["closer"],
      onClick: () =>
        history.push({
          pathname: "/lead",
          state: { pa: PATIENT_ASSIGNMENT.CLINIC, isCloser: true },
        }),
    },
    {
      name: "Sign Up",
      key: "closer_closer_signup",
      roles: ["closer"],
      onClick: () =>
        history.push({
          pathname: "/lead",
          state: { pa: PATIENT_ASSIGNMENT.SIGN_UP, isCloser: true },
        }),
    },
    {
      name: "Not Interested",
      key: "closer_closer_notinterested",
      roles: ["closer"],
      onClick: () =>
        history.push({
          pathname: "/lead",
          state: { pa: PATIENT_ASSIGNMENT.NOT_INTERESTED, isCloser: true },
        }),
    },
    {
      name: "ADHC",
      key: "closer_closer_adhc",
      roles: ["closer"],
      onClick: () =>
        history.push({
          pathname: "/lead",
          state: { pa: PATIENT_ASSIGNMENT.ADHC, isCloser: true },
        }),
    },
    {
      name: "Pharmacy",
      key: "closer_closer_pharmacy",
      roles: ["closer"],
      onClick: () =>
        history.push({
          pathname: "/lead",
          state: { pa: PATIENT_ASSIGNMENT.PHARMACY, isCloser: true },
        }),
    },*/
    {
      name: "Closer",
      key: "admin_closer",
      roles: ["admin","closer"],
      items: [
        {
          name: "All",
          key: "admin_closer_all",
          roles: ["admin","closer"],
          onClick: () =>
            history.push({
              pathname: "/lead",
              state: {
                isCloser: true,
              },
            }),
        },
        {
          name: "Home Health",
          key: "admin_closer_homehealth",
          roles: ["admin","closer"],
          onClick: () =>
            history.push({
              pathname: "/lead",
              state: { pa: PATIENT_ASSIGNMENT.HOME_HEALTH, isCloser: true },
            }),
        },
        {
          name: "Hospice",
          key: "admin_closer_hospice",
          roles: ["admin","closer"],
          onClick: () =>
            history.push({
              pathname: "/lead",
              state: { pa: PATIENT_ASSIGNMENT.HOSPICE, isCloser: true },
            }),
        },
        {
          name: "Clinic",
          key: "admin_closer_clinic",
          roles: ["admin","closer"],
          onClick: () =>
            history.push({
              pathname: "/lead",
              state: { pa: PATIENT_ASSIGNMENT.CLINIC, isCloser: true },
            }),
        },
        {
          name: "Sign Up",
          key: "admin_closer_signup",
          roles: ["admin","closer"],
          onClick: () =>
            history.push({
              pathname: "/lead",
              state: { pa: PATIENT_ASSIGNMENT.SIGN_UP, isCloser: true },
            }),
        },
        {
          name: "ADHC",
          key: "admin_closer_adhc",
          roles: ["admin","closer"],
          onClick: () =>
            history.push({
              pathname: "/lead",
              state: { pa: PATIENT_ASSIGNMENT.ADHC, isCloser: true },
            }),
        },
        {
          name: "Pharmacy",
          key: "admin_closer_pharmacy",
          roles: ["admin","closer"],
          onClick: () =>
            history.push({
              pathname: "/lead",
              state: { pa: PATIENT_ASSIGNMENT.PHARMACY, isCloser: true },
            }),
        },
      ],
    },
    {
      name: "Lead",
      key: "lead",
      roles: ["admin", "manager", "central-user", "staff"],
      onClick: function () {
        history.push("/lead");
      },
    },
    {
      name: "Leads",
      key: "assigned-vendor",
      roles: ["vendor"],
      onClick: function () {
        history.push(ROUTE.ASSIGNED_VENDOR);
      },
    },
    
    {
      name: "Approval",
      key: "approve",
      roles: ["admin"],
      onClick: function () {
        history.push("/approve");
      },
    },
    {
      name: "Report",
      key: "Report",
      roles: ["admin", "manager"],
      items: [
        {
          name: "LG Report",
          key: "staff_report",
          roles: ["admin", "manager"],
          onClick: function () {
            history.push("/staff-report");
          },
        },
        {
          name: "CU Report",
          key: "cu_report",
          roles: ["admin", "manager"],
          onClick: function () {
            history.push("/cu-report");
          },
        },
        {
          name: "Lead Report",
          key: "lead_report",
          roles: ["admin", "manager"],
          onClick: function () {
            history.push("/lead-report");
          },
        },
        {
          name: "Assignment Logging",
          key: "assignment_logging",
          roles: ["admin"],
          onClick: function () {
            history.push("/assignment-logging");
          },
        },
      ],
    },
    {
      name: "Management",
      key: "Management",
      roles: ["admin", "manager"],
      items: [
        {
          name: "ZipCode & Phone Assignment",
          key: "zipcodeassigment",
          roles: ["admin", "manager"],
          onClick: function () {
            history.push("/zipcodeassigment");
          },
        },
        // {
        //   name: "Assign Staff to Manager",
        //   key: "assign staff",
        //   roles: ["admin"],
        //   onClick: function () {
        //     history.push("/assign-staff");
        //   },
        // },
        // {
        //   name: "Move Staff To Manager",
        //   key: "stafftomanager",
        //   roles: ["admin"],
        //   onClick: function () {
        //     history.push("/staff-to-manager");
        //   },
        // },
        {
          name: "Add New Account",
          key: "addnewaccount",
          roles: ["admin"],
          onClick: function () {
            history.push("/register");
          },
        },
        {
          name: "Manage User",
          key: "manageuser",
          roles: ["admin"],
          onClick: function () {
            history.push("/manage-user");
          },
        },
        {
          name: "Import Data",
          key: "import-data",
          roles: ["admin"],
          onClick: function () {
            history.push("/import-data");
          },
        },
        {
          name: "Staff Activities",
          key: "staff-activities",
          roles: ["admin"],
          onClick: function () {
            history.push("/staff-activities");
          },
        },
        {
          name: "Health Plans",
          key: "health-plans",
          roles: ["admin"],
          onClick: () => {
            history.push("/health-plans");
          },
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./client/components/common/NavBar.js